import React from 'react'
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import {useGetGenericHtmlPage} from '../../custom-api/hooks/use-get-generic-html-page'
import {Helmet} from 'react-helmet'
import loadable from '@loadable/component'
import {Box, useMultiStyleConfig} from '@chakra-ui/react'
import SanitizedHtml from '../../components/html-sanitizer'

const PageNotFound = loadable(() => import('./../page-not-found'))

const GenericHtmlPage = () => {
    const {res} = useServerContext()
    const {data, error, isLoading} = useGetGenericHtmlPage()
    const entries = {...data}
    const stylesPolicies = useMultiStyleConfig('Policies')

    if (error || (data === null && !isLoading)) {
        if (res) res.status(404)
        return <PageNotFound />
    }

    const seo = entries?.seo_standard || {}
    const metaTitle = seo?.meta_title
    const metaDescription = seo?.meta_description

    return (
        <>
            <Helmet>
                {metaTitle && <title>{metaTitle}</title>}
                {metaDescription && <meta name="description" content={metaDescription} />}
            </Helmet>
            <Box {...stylesPolicies.container} __css={{...stylesPolicies}}>
                <SanitizedHtml as="div" html={data?.html} />
            </Box>
        </>
    )
}

export default GenericHtmlPage
